import { SxProps, Theme } from "@mui/material";

export const root: (isShowingMenu: boolean) => SxProps<Theme> = (isShowingMenu: boolean) => (theme) => ({
	textTransform: "none",
	width: "100%",
	justifyContent: "space-between",
	backgroundColor: isShowingMenu ? theme.palette.primary.light : "initial",
	marginBottom: theme.spacing(1),
	height: theme.spacing(6),
});

export const icon: (isShowingMenu: boolean) => SxProps<Theme> = (isShowingMenu: boolean) => (theme) => ({
	display: "flex",
	alignItems: "center",
	color: theme.palette.info.main,
	backgroundColor: isShowingMenu ? theme.palette.background.default : "initial",
	borderRadius: "100%",
	":hover": {
		backgroundColor: theme.palette.background.default,
	},
});
